/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { CONTEXT } from "constants/constants";

export const scaleRectangle = (rect, scale) => ({
  left: rect.left * scale,
  right: rect.right * scale,
  top: rect.top * scale,
  bottom: rect.bottom * scale
});

export const translateRectangle = (rect, x, y) => ({
  left: rect.left + x,
  right: rect.right + x,
  top: rect.top + y,
  bottom: rect.bottom + y
});

export const rectsIntersection = (rect1, rect2) => ({
  left: Math.max(rect1.left, rect2.left),
  right: Math.min(rect1.right, rect2.right),
  top: Math.max(rect1.top, rect2.top),
  bottom: Math.min(rect1.bottom, rect2.bottom)
});

export const convertHexToRGB = hex => {
  // TO DO
  try {
    let rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    let r = parseInt(rgb[1], 16) / 255.0;
    let g = parseInt(rgb[2], 16) / 255.0;
    let b = parseInt(rgb[3], 16) / 255.0;
    return `${r} ${g} ${b} RG`;
  } catch (exc) {
    return hex;
  }
};

export const isIntegrationContext = context => context && context === CONTEXT.INTEGRATION;

export const isNotANegativeNumber = value => typeof value === "number" && value >= 0;
